<template>
    <nav>
        <h2>Programas presupuestales</h2>
        <ul class="list-group">
            <li v-for="(item, index) in sidebar" :key="index" :class="[{ active: String($route.fullPath).includes(item.path) }, 'list-group-item']">                
                <router-link :to="item.path">
                    {{ item.tag }}
                </router-link>
            </li>            
        </ul>
    </nav>
</template>
<script>
export default {
    name: "Sidebar",
    props: {
        sidebar: {
            type: Array,
            default: () => []
        }
    },
}
</script>
<style scoped>
    nav {
        margin-bottom: 3em;
    }
</style>